import AkkaLink from '@commons/AkkaLink/AkkaLink';

/**
 * Blurb link wrapper that makes content clickable.
 * Use this to wrap the entire Blurb or specific parts.
 */
export default function BlurbLink({ href, onClick = undefined, children, className = '', overlay = false }) {
  if (!href) return children;

  const overlayClass = overlay ? 'Blurb__link--overlay' : '';
  const finalClassName = `Blurb__link ${overlayClass} ${className}`.trim();

  return (
    <AkkaLink href={href} onClick={onClick} className={finalClassName}>
      {children}
    </AkkaLink>
  );
}
